// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".special-charge-window label {\n  font-size: 12px;\n  font-weight: normal;\n}\n.special-charge-window .el-select {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
